import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import AboutUs from "./components/About";
import Contact from "./components/Contact";
import ErrorBoundary from "./components/ErrorBoundary";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import VehicleShowcase from "./components/VehicleShowcase";
import AddSeo from "./components/AddSeo";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <HelmetProvider>
          <AddSeo
            title="Elam Travels Trichy | Car Rentals, Tour Packages, and Travel Agency in Trichy"
            description="Elam Travels in Trichy offers affordable car rentals, outstation taxis, and cabs for hire. Choose from budget-friendly 4 to 7-seater options, including Maruti Swift Dzire, Toyota Etios, and Innova Crysta, tailored to your travel needs. Book now for reliable and comfortable rides!"
            keywords="Elam Travels, Travels in Trichy, Car Rentals in Trichy, Outstation Taxi Trichy, Trichy Airport Taxi, Tempo Traveller Trichy, Tour Packages Trichy, Travel Agency in Trichy, Trichy Tours and Travels, Affordable Car Rentals, Family Tour Packages Trichy, Tirupati Tour Package Trichy, Kerala Tour Package Trichy, Honeymoon Packages Trichy, Best Travel Agency Trichy, South India Travel Packages, Budget Car Rentals Trichy, Online Car Booking Trichy, Innova Rental Trichy, Etios Rental Trichy"
          />
          <Header />
          <Hero />
          <AboutUs />
          <VehicleShowcase />
          <Services />
          <Contact />
          <Footer />
        </HelmetProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
